<template>
  <header class="relative z-40">
    <div class="w-full shadow-md relative" :class="whiteLabel.darkHeader ? 'bg-dark' : 'bg-white'">
      <div class="max-w-3xl mx-auto px-5">
        <div class="flex justify-between items-center">
          <!-- Logo -->
          <router-link :to="{ ...baseRouteConfig, name: 'dashboard' }">
            <img class="logo py-2" :src="whiteLabel.logoUrl" alt="logo" />
          </router-link>

          <!-- Right section -->
          <div class="flex items-center py-5">
            <!-- Languages -->
            <Languages v-if="!isMobile" class="mr-5" />

            <!-- Assistance tooltip -->
            <Tooltip v-if="!isPrestigeCapital" ref="tooltip" class="mr-5" arrow-to="top" tool-tip-class="w-56">
              <template #reference>
                <span
                  class="icon-reporting_icon text-2lg cursor-pointer hover:text-primary transition__normal"
                  :class="whiteLabel.darkHeader ? 'text-white' : ''"
                ></span>
              </template>

              <div class="text-center pt-3">
                <span class="icon-reporting_icon text-2lg text-grey mb-3 inline-block"></span>
                <p class="text-primary text-base mb-3">{{ $t('Need Assistance?') }}</p>
                <ButtonModule small class="text-4xs font-bold py-2 px-8 mx-auto mb-2" @click.stop="openHelpModal">
                  {{ $t('Request Help') }}
                </ButtonModule>
              </div>
            </Tooltip>

            <!-- Notifications -->
            <DropdownModule
              transition-name="scale"
              class="mr-5"
              dropdown-class="notification w-72 md:w-80 bg-grey-lightest"
            >
              <template #reference>
                <div class="relative">
                  <span
                    class="icon-notifications_icon mr-1 text-4lg cursor-pointer hover:text-primary transition__normal"
                    :class="whiteLabel.darkHeader ? 'text-white' : ''"
                  ></span>
                  <IndicatorModule
                    v-if="notifications && notifications.length"
                    indicator-class="bg-red absolute top-0 right-0 w-2 h-2"
                  />
                </div>
              </template>
              <Notification />
            </DropdownModule>

            <!-- User Menu -->
            <div class="relative">
              <MobileMenu v-if="isMobile" :is-visible="showUserMenu" @close="showUserMenu = false" />
              <UserDropdown v-else />
            </div>
          </div>
        </div>
      </div>
    </div>

    <HelpModal :is-visible="showHelpModal" @close="closeHelpModal" />
  </header>
</template>

<script>
import ButtonModule from '@/components/shared/ButtonModule'
import Tooltip from '@/components/shared/Tooltip'
import UserDropdown from '@/components/header-components/UserDropdown'
import Notification from '@/components/header-components/Notification'
import Languages from '@/components/header-components/Languages'
import MobileMenu from '@/components/header-components/MobileMenu'
import HelpModal from '@/components/header-components/HelpModal'
import DropdownModule from '@/components/shared/DropdownModule'
import IndicatorModule from '@/components/shared/IndicatorModule'
import { useGeneralStore } from '@/stores/general'
import { useInvestorStore } from '@/stores/investor'
import { useCompanyStore } from '@/stores/company'

export default {
  name: 'MainHeader',

  components: {
    DropdownModule,
    ButtonModule,
    Tooltip,
    UserDropdown,
    Notification,
    Languages,
    IndicatorModule,
    MobileMenu,
    HelpModal
  },

  setup () {
    const generalStore = useGeneralStore()
    const investorStore = useInvestorStore()
    const companyStore = useCompanyStore()

    return {
      generalStore,
      investorStore,
      companyStore
    }
  },

  data () {
    return {
      showUserMenu: false,
      showHelpModal: false
    }
  },

  computed: {
    isMobile () {
      return this.generalStore.isMobile
    },
    whiteLabel () {
      return this.companyStore.whiteLabel
    },
    isSkyline () {
      return this.generalStore.isSkyline
    },
    baseRouteConfig () {
      return this.companyStore.baseRouteConfig
    },
    isPrestigeCapital () {
      return this.investorStore.isPrestigeCapital
    },
    currentInvestor () {
      return this.investorStore.currentInvestor
    },
    notifications () {
      return this.generalStore.notifications
    }
  },

  methods: {
    openHelpModal () {
      this.showHelpModal = true
      this.$refs.tooltip?.toggle?.()
    },
    closeHelpModal () {
      this.showHelpModal = false
    }
  }
}
</script>

<style scoped>
.logo {
  max-width: 160px;
}

@media (min-width: 480px) {
  .logo {
    height: 66px;
    max-width: unset;
  }
}
</style>
